import { InfoLabel, Text, TextProps } from '@fluentui/react-components';
import { Column, ColumnProps } from './Column';
import { useCommonStyles } from './Styles/commonStyles';

type SectionHeaderProps = ColumnProps & {
    title: string | JSX.Element;
    info?: string | JSX.Element;
    description?: string | JSX.Element;
    children?: React.ReactNode;
    titleProps?: TextProps | ColumnProps;
    descriptionProps?: TextProps;
    childrenListProps?: ColumnProps;
};
export const Section = (props: SectionHeaderProps) => {
    const { title, info, description, children, titleProps, descriptionProps, childrenListProps, ...otherProps } = props;

    const commonStyles = useCommonStyles();

    return (
        <Column
            gap='medium'
            height='auto'
            padding='px-3 pt-2 pb-3'
            borderRadius='8px'
            minHeight='fit-content'
            {...otherProps}
        >
            <Column height='auto' bottomBorder  noGap>
                <InfoLabel info={info}>
                    {typeof title === 'string' ? (
                        <Text size={400} italic weight='bold' className={commonStyles.text.subtleText} {...titleProps as TextProps}>
                            {title}
                        </Text>
                    ) : (
                        <>{title}</>
                    )}
                </InfoLabel>
                {description && (
                    <Text size={200} className={commonStyles.text.subtleText} {...descriptionProps}>
                        {description}
                    </Text>
                )}
            </Column>
            <Column height='auto' gap='medium' {...childrenListProps}>
                {children}
            </Column>
        </Column>
    );
};
